/**
 * Shared helpers to detect and surface Cloudflare Turnstile / Clerk
 * bot-protection failures with a human-readable message.
 *
 * Clerk's built-in "bot protection" renders Cloudflare Turnstile into the
 * `#clerk-captcha` / `#clerk-captcha-step-2` containers. If the challenge
 * cannot be solved (e.g. the sitekey is not authorized for the calling
 * domain, or third-party storage / tracking protection blocks the widget),
 * the failing request surfaces one of the TURNSTILE_ERROR_CODES below or the
 * Cloudflare `600010` message inside the error chain. Without a resolved
 * challenge, Clerk cannot create/verify the account and the user would
 * otherwise hang on a generic, unhelpful message.
 */
const TURNSTILE_ERROR_CODES = new Set([
  'captcha_invalid',
  'captcha_challenge_failed',
  'captcha_expired',
  'captcha_required',
  'bot_protection_required',
  'captcha_not_passed',
  'challenge_failed',
]);

export function isTurnstileError(err: any): boolean {
  if (!err) return false;
  const code = err.code || err.errors?.[0]?.code;
  if (code && TURNSTILE_ERROR_CODES.has(String(code))) return true;
  const message = [
    err.message,
    err.errors?.[0]?.message,
    err.errors?.[0]?.longMessage,
  ]
    .filter(Boolean)
    .join(' ');
  return (
    message.includes('600010') ||
    message.toLowerCase().includes('turnstile') ||
    message.toLowerCase().includes('captcha')
  );
}

/**
 * Tolgee-Key zur Meldung unten. Liegt hier, damit Komponenten
 * `t(TURNSTILE_USER_MESSAGE_KEY, TURNSTILE_USER_MESSAGE)` schreiben können —
 * dieses Modul ist kein React-Kontext und kann den Hook nicht selbst aufrufen.
 */
export const TURNSTILE_USER_MESSAGE_KEY = 'auth_signin_error_captcha';

export const TURNSTILE_USER_MESSAGE =
  'Die Sicherheitsprüfung (CAPTCHA) konnte nicht abgeschlossen werden. ' +
  'Bitte laden Sie die Seite neu und versuchen Sie es erneut. ' +
  'Falls das Problem bestehen bleibt, deaktivieren Sie Tracker-Blocker / ' +
  'Adblocker für diese Seite oder öffnen Sie sie in einem privaten Fenster.';
